<script setup lang="ts">
import { SvgHelpOutline } from '@repo/icons';

import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { onMounted } from 'vue';

const steps = [
  {
    element: '#detail-tabitem',
    popover: {
      title: '面料详情',
      description: '查看面料详情，同时查看使用纱线介绍及同纱线其他面料'
    }
  },
  {
    element: `#cloud-button`,
    popover: {
      title: '云库',
      description: '搭配廓形，可选择数千个廓形查看搭配效果'
    }
  },
  {
    element: `#exhibition-button`,
    popover: {
      title: '展厅',
      description: '主题展厅，可以查看企业主推的系列产品内容'
    }
  },
  {
    element: `#more-button`,
    popover: {
      title: '更多',
      description: '点击展开，试衣查看上身效果，编辑可以调节配色及面料搭配效果'
    }
  },
  {
    element: `#scan-button`,
    popover: {
      title: '扫一扫',
      description: '点击可以扫面料二维码切换面料或者款式二维码切换款式'
    }
  }
];

const handleDriverIntro = () => {
  driver({
    nextBtnText: '下一个',
    prevBtnText: '上一个',
    doneBtnText: '完成',
    showProgress: true,
    steps: steps
  }).drive();
  localStorage.setItem('intro', `${Date.now()}`);
};

onMounted(() => {
  const intro = localStorage.getItem('intro');
  if (!intro) {
    handleDriverIntro();
  }
});
</script>

<template>
  <div @click="handleDriverIntro">
    <SvgHelpOutline style="width: 20px;height:20px; color: white;" />
  </div>
</template>

<style module>

</style>
